/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  ArtifactsPredictImpactCreateBody,
  ImpactPredictResponse
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Run ML prediction for Impact solution and return artifact report.

        Supports three execution modes via optional 'mode' field:
        - 'new' (default): Create new artifact with 24h expiration
        - 'explore': Create temporary variant of existing artifact (requires 'old_artifact_id')
        - 'rerun': Refresh hashes on existing artifact without retraining (requires 'id')

        Explore mode returns report with 'old_artifact_id' and 'new_artifact_id' for use with /replace/ endpoint.

        **Request Body**: Use write-only fields for input:
        - `project_solution_id`: number (not nested object)
        - `dependent_driver_id`: number (not nested object)
        - `independent_driver_ids`: number[] (not nested array of objects)
        - `model_object`: Blob | null (file upload, not string path)
        - Do NOT include `id` field (server-generated)
        
 * @summary Predict Impact artifact model
 */
export const artifactsPredictImpactCreate = (
    artifactsPredictImpactCreateBody: ArtifactsPredictImpactCreateBody,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ImpactPredictResponse>(
      {url: `/api/artifacts/predict/impact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: artifactsPredictImpactCreateBody, signal
    },
      );
    }
  


export const getArtifactsPredictImpactCreateMutationOptions = <TError = ImpactPredictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artifactsPredictImpactCreate>>, TError,{data: ArtifactsPredictImpactCreateBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof artifactsPredictImpactCreate>>, TError,{data: ArtifactsPredictImpactCreateBody}, TContext> => {

const mutationKey = ['artifactsPredictImpactCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof artifactsPredictImpactCreate>>, {data: ArtifactsPredictImpactCreateBody}> = (props) => {
          const {data} = props ?? {};

          return  artifactsPredictImpactCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArtifactsPredictImpactCreateMutationResult = NonNullable<Awaited<ReturnType<typeof artifactsPredictImpactCreate>>>
    export type ArtifactsPredictImpactCreateMutationBody = ArtifactsPredictImpactCreateBody
    export type ArtifactsPredictImpactCreateMutationError = ImpactPredictResponse

    /**
 * @summary Predict Impact artifact model
 */
export const useArtifactsPredictImpactCreate = <TError = ImpactPredictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof artifactsPredictImpactCreate>>, TError,{data: ArtifactsPredictImpactCreateBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof artifactsPredictImpactCreate>>,
        TError,
        {data: ArtifactsPredictImpactCreateBody},
        TContext
      > => {

      const mutationOptions = getArtifactsPredictImpactCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    